import { AttributeName, IModel, IVehicleType } from '@cbgms/api'
import { GridCellParams, GridFilterItem, GridFilterOperator } from '@mui/x-data-grid-pro'
import { GridHeaderFilterSingleSelect } from './GridHeaderFilterSingleSelect'
import { FilterOption } from './types.d'
import { filterDateRange } from 'app/hooks/useFilter'
import { parseVehicleDate } from './Helpers'

interface IAttributeKeyValues {
  [key: string]: string
}

const extraDateRangeFilter = (filter: string, from: string, until: string) => {
  return filterDateRange(filter, parseVehicleDate(from), parseVehicleDate(until))
}

export const extraDateRangeFilterType = (filter: string, type: IVehicleType) =>
  extraDateRangeFilter(filter, type.GenericVehicle.MadeFrom, type.GenericVehicle.MadeUntil)
export const extraDateRangeFilterModel = (filter: string, model: IModel) => extraDateRangeFilter(filter, model.MadeFrom, model.MadeUntil)
export const extraDateRangeFilterVPOM = (filter: string, attr: IAttributeKeyValues) =>
  extraDateRangeFilter(
    filter,
    attr[AttributeName.EMDMDateFrom] || attr[AttributeName.TecDocPlusDateFrom],
    attr[AttributeName.EMDMDateTo] || attr[AttributeName.TecDocPlusDateTo]
  )

export const GridDateRangeIncludes = (props: { options: FilterOption[] }, format: string): GridFilterOperator[] => [
  {
    label: 'is',
    value: 'is',
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator) {
        return null
      }
      if (format === 'type') {
        return (params: GridCellParams<IVehicleType, string>): boolean => {
          const filterYear = filterItem.value // filterItem.value: selected year in dropdown
          return extraDateRangeFilterType(filterYear, params.row)
        }
      }
      if (format === 'model') {
        return (params: GridCellParams<IModel, string>): boolean => {
          const filterYear = filterItem.value // filterItem.value: selected year in dropdown
          return extraDateRangeFilterModel(filterYear, params.row)
        }
      }
      if (format === 'vpom') {
        return (params: GridCellParams<IAttributeKeyValues, string>): boolean => {
          const filterYear = filterItem.value // filterItem.value: selected year in dropdown
          return extraDateRangeFilterVPOM(filterYear, params.row)
        }
      }
      return (): boolean => false
    },
    InputComponent: GridHeaderFilterSingleSelect,
    InputComponentProps: props
  }
]
